import { service } from '@ember/service';
import Controller from '@ember/controller';

export default class WidgetController extends Controller {
  @service currentPractice;
  @service session;
  @service prescreener;
}
